export const ASYNC_STATUS = {
  UNINITIALIZED: 'UNINITIALIZED',
  STARTED: 'STARTED',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
};
export const uninitialized = data => ({
  data,
  status: ASYNC_STATUS.UNINITIALIZED
});
export const started = data => ({
  data,
  status: ASYNC_STATUS.STARTED
});
export const succeeded = data => ({
  data,
  status: ASYNC_STATUS.SUCCEEDED
});
export const failed = data => ({
  data,
  status: ASYNC_STATUS.FAILED
});
export const isSucceeded = state => (state === null || state === void 0 ? void 0 : state.status) === ASYNC_STATUS.SUCCEEDED;